import classNames from "classnames";
import React, { FC, useContext, useRef, useState } from "react";
import { BsShare } from "react-icons/bs";
import useBreakpoint from "../../hooks/useBreakpoint";
import { deviceTypeContext } from "../../utils/deviceTypeContext";
import Share from "../Share";
import Image from 'next/image';
import FavoriteToggle from "../FavoriteToggle";

type BannerProps = {
  text: string;
  subText?: string;
  color: string;
  image?: string;
  altText: string;
  id?: number;
  type?: string;
};

const Banner: FC<BannerProps> = ({
  text: name,
  subText,
  color,
  image,
  altText,
  type,
  id
}) => {
  const [showShareIcons, setShowShareIcons] = useState(false);
  const buttonRef = useRef(null);
  // TODO: Use fresnel instead
  const isAboveMd = useBreakpoint("md", useContext(deviceTypeContext)!);

  return (
    <div
      className={classNames(
        "p-5",
        "gap-3",
        "w-full",
        "flex",
        "flex-col",
        "md:flex-row",
        "items-center"
      )}
      style={{ backgroundColor: color }}
    >
      {image && (
        <Image
          src={image}
          alt={altText}
          className="object-cover"
          width={100}
          height={100}
        />
      )}

      <div
        className={classNames("flex", "justify-center", "gap-8", "mx-5", {
          "w-full": !isAboveMd,
        })}
      >
        <h1
          className={classNames(
            "text-white",
            "text-4xl",
            "font-bold",
            "line-clamp-3",
            "pb-[0.1em]"
          )}
          style={{ wordBreak: "break-word" }}
        >
          {name}
          {subText && (
            <span className={classNames("block", "text-base", "mt-1.5")}>
              {subText}
            </span>
          )}
        </h1>
        <div
          className={classNames(
            "flex",
            "items-center",
            "hover:cursor-pointer",
            "select-none"
          )}
        >
          <div ref={buttonRef}>
            <BsShare
              onClick={() => setShowShareIcons(!showShareIcons)}
              style={{
                width: "1.5rem",
                height: "1.5rem",
                color: "white",
              }}
            />
          </div>
          <Share
            buttonRef={buttonRef}
            isOpen={showShareIcons}
            iconColor={color}
          />
        </div>

        <div
          className={classNames(
            "flex",
            "items-center",
            "hover:cursor-pointer",
            "select-none"
          )}
        >
          {type && id && image && (
            <FavoriteToggle
              type={type}
              favorite={{
                id,
                image: image,
                name,
              }}
              style={{
                width: "1.5rem",
                height: "1.5rem",
                color: "white",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Banner;
